import ChargebeeWidgetContainer from "../ChargebeeWidget";
import { ChargebeeWidgetForward } from "../ChargebeeWidget/ChargebeeWidget";

export default function OrganizationBillingHistory() {
  return (
    <ChargebeeWidgetContainer forward={ChargebeeWidgetForward.BillingHistory} />
  );
}
